var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGridIconLargeInactive = function SvgGridIconLargeInactive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_169",
    "data-name": "Group 169",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.03,
    height: 56.267,
    viewBox: "0 0 100.03 56.267",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M685.047,535.351h-99.03V480.084h99.03Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M586.518,480.584v54.267h98.03V480.584h-98.03m-1-1h100.03v56.267H585.517Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M588.506,482.508h30.037v15.5H588.506Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-2",
    "data-name": "Grey Box-2",
    d: "M588.506,500.009h30.037v15.5H588.506Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-3",
    "data-name": "Grey Box-3",
    d: "M588.506,517.333h30.037v15.5H588.506Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-4",
    "data-name": "Grey Box-4",
    d: "M620.5,482.508H650.54v15.5H620.5Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-5",
    "data-name": "Grey Box-5",
    d: "M620.5,500.009H650.54v15.5H620.5Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-6",
    "data-name": "Grey Box-6",
    d: "M620.5,517.333H650.54v15.5H620.5Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-7",
    "data-name": "Grey Box-7",
    d: "M652.5,482.509h30.037v15.5H652.5Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-8",
    "data-name": "Grey Box-8",
    d: "M652.5,500.01h30.037v15.5H652.5Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-9",
    "data-name": "Grey Box-9",
    d: "M652.5,517.334h30.037v15.5H652.5Z",
    transform: "translate(-585.518 -479.584)",
    fill: "#ccd3da"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGridIconLargeInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grid-icon-large-inactive.cdb140ec9eec946d647b54c115f42f7a.svg";